<div *ngIf="hierarchyItem && (!hierarchyItem.isChangeKey || showChangeKeys)" class="menu-container">
  <div *ngIf="crossKeyHierarchy">
    <mat-checkbox
      [(ngModel)]="hierarchyItem.checked"
      [(indeterminate)]="hierarchyItem.indeterminateCheckBox"
      [disabled]="
        hierarchyItem.disabledCheckBox ||
        hierarchyItem?.masterKeyType?.name === 'CrossKey' ||
        hierarchyItem?.masterKeyType?.name === 'CrossKeyChild'
      "
      (change)="toggleCrossKeySelection($event.checked)"
    ></mat-checkbox>
  </div>

  <div *ngIf="ownOperatingKey">
    <mat-radio-button (change)="selectIncludedParent(hierarchyItem)"> </mat-radio-button>
  </div>

  <!-- Key Set Symbol -->
  <div class="keyset-symbol-wrapper">
    <div class="keyset-symbol 3">
      <div
        *ngFor="let level of hierarchyItem?.lineTracker | keyvalue; let first = first; let last = last"
        class="lines"
      >
        <div *ngIf="level.value.key === hierarchyItem.keySetSymbol" class="top"></div>
        <div class="bottom" [ngClass]="{ 'no-border': level.value.value }"></div>
      </div>

      <lib-key [hierarchyItem]="hierarchyItem" [canMinimize]="true" [showChangeKeys]="showChangeKeys"> </lib-key>
    </div>
  </div>

  <!-- Key Section -->
  <div class="col" *ngIf="!crossKeyHierarchy && !(budgetHierarchy && hierarchyItem?.masterKeyTypeId === keyNodeType.ControlKeyMaster)">
    <div class="input">
      <input
        matInput
        *ngIf="keySystem"
        aria-describedby="keySections"
        [matAutocomplete]="autoFillKeyways"
        [(ngModel)]="hierarchyItem.keyway"
        (ngModelChange)="saveKeyway($event, hierarchyItem)"
        (focus)="loadKeyways(hierarchyItem)"
        [disabled]="budgetHierarchy && hierarchyItem?.masterKeyTypeId === keyNodeType.ControlKey"
      />

      <mat-autocomplete #autoFillKeyways="matAutocomplete" [displayWith]="displayName">
        <mat-option *ngFor="let keySection of childKeySections" [value]="keySection">
          {{ keySection.name }}
        </mat-option>
      </mat-autocomplete>
    </div>
  </div>

  <!-- Assigned Keys -->
  <div class="col small" *ngIf="!crossKeyHierarchy && !(budgetHierarchy && hierarchyItem?.masterKeyTypeId === keyNodeType.ControlKeyMaster)">
    <span *ngIf="!hierarchyItem?.isChangeKey && hierarchyItem?.masterKeyTypeId !== keyNodeType.SelectiveMaster">
      <mat-checkbox [checked]="hierarchyItem.isAssigned" [disabled]="true"></mat-checkbox>
    </span>
  </div>

  <!-- Future Keys -->
  <div class="col small" *ngIf="!crossKeyHierarchy && !ownOperatingKey && !(budgetHierarchy && hierarchyItem?.masterKeyTypeId === keyNodeType.ControlKeyMaster)">
    <span *ngIf="!hierarchyItem?.isChangeKey && hierarchyItem?.masterKeyTypeId !== keyNodeType.SelectiveMaster">
      <mat-checkbox [checked]="hierarchyItem.isFutureKey" [disabled]="true"></mat-checkbox>
    </span>
  </div>

  <!-- Change Key Expansion -->
  <div class="col" *ngIf="!crossKeyHierarchy && !ownOperatingKey && !(budgetHierarchy && hierarchyItem?.masterKeyTypeId === keyNodeType.ControlKeyMaster)">
    <div
      class="input"
      *ngIf="
        !hierarchyItem?.isChangeKey &&
        !hasChildren(hierarchyItem) &&
        hierarchyItem?.masterKeyTypeId !== keyNodeType.SelectiveMaster
      "
    >
      <input
        type="number"
        min="0"
        [disabled]="budgetHierarchy && hierarchyItem?.masterKeyTypeId === keyNodeType.ControlKey"
        [(ngModel)]="hierarchyItem.changeKeyExpansion"
        (blur)="
          patchItem({
            type: 'masterKey',
            masterKey: hierarchyItem,
            path: '/ChangeKeyExpansion',
            value: hierarchyItem.changeKeyExpansion
          })
        "
        (keyup.enter)="
          patchItem({
            type: 'masterKey',
            masterKey: hierarchyItem,
            path: '/ChangeKeyExpansion',
            value: hierarchyItem.changeKeyExpansion
          })
        "
      />
    </div>
  </div>

  <!-- Budget -->
  <div class="col small" *ngIf="!crossKeyHierarchy && !ownOperatingKey && !(budgetHierarchy && hierarchyItem?.masterKeyTypeId === keyNodeType.ControlKeyMaster)">
    <span *ngIf="!hierarchyItem?.isChangeKey && hierarchyItem?.masterKeyTypeId !== keyNodeType.SelectiveMaster">
      {{ hierarchyItem.budget }}
    </span>
  </div>

  <!-- Notes -->
  <div class="col" *ngIf="!(budgetHierarchy && hierarchyItem?.masterKeyTypeId === keyNodeType.ControlKeyMaster)">
    <div class="input">
      <input
        [disabled]="crossKeyHierarchy || ownOperatingKey"
        [(ngModel)]="hierarchyItem.note"
        (blur)="
          patchItem({
            type: 'note',
            masterKey: hierarchyItem,
            path: '/message',
            value: hierarchyItem.note
          })
        "
        (keyup.enter)="
          patchItem({
            type: 'note',
            masterKey: hierarchyItem,
            path: '/message',
            value: hierarchyItem.note
          })
        "
      />
    </div>
  </div>

  <lib-key-actions
    *ngIf="!crossKeyHierarchy && !(budgetHierarchy && hierarchyItem?.masterKeyTypeId === keyNodeType.ControlKeyMaster)"
    [hierarchyItem]="hierarchyItem"
    [keySystem]="keySystem"
    [isResidentialSystem]="isResidentialSystem"
    [budgetHierarchy]="budgetHierarchy"
    (deleteItemAction)="deleteItem($event)"
    (patchItemAction)="patchItem($event)"
    (addChildAction)="addChild($event)"
  >
  </lib-key-actions>
</div>

<ng-container
  *ngIf="hierarchyItem && !hierarchyItem.isChangeKey && hierarchyItem.children && hierarchyItem.children.length > 0"
>
  <div *ngFor="let child of hierarchyItem.sortedChildren; let last = last">
    <lib-menu-item
      *ngIf="
        !hierarchyItem?.isMinimized &&
        !(child.isChangeKey && isResidentialSystem && crossKeyHierarchy) &&
        child?.masterKeyTypeId !== 10
      "
      [showChangeKeys]="showChangeKeys"
      [hierarchyItem]="child"
      [lastChild]="last"
      [crossKeyHierarchy]="crossKeyHierarchy"
      [ownOperatingKey]="ownOperatingKey"
      [keySystem]="keySystem"
      [isResidentialSystem]="isResidentialSystem"
      [budgetHierarchy]="budgetHierarchy"
      [keyways]="keyways"
      [structure]="structure"
      (selectKey)="selectIncludedParent($event)"
      (deleteItemAction)="deleteItem($event)"
      (patchItemAction)="patchItem($event)"
      (addChildAction)="addChild($event)"
    >
    </lib-menu-item>
    <lib-menu-item
      *ngIf="thruNode"
      [showChangeKeys]="showChangeKeys"
      [hierarchyItem]="thruNode"
      [lastChild]="last"
      [crossKeyHierarchy]="crossKeyHierarchy"
      [ownOperatingKey]="ownOperatingKey"
      [keySystem]="keySystem"
      [isResidentialSystem]="isResidentialSystem"
      [budgetHierarchy]="budgetHierarchy"
      [keyways]="keyways"
      [structure]="structure"
      (selectKey)="selectIncludedParent($event)"
      (deleteItemAction)="deleteItem($event)"
      (patchItemAction)="patchItem($event)"
      (addChildAction)="addChild($event)"
    >
    </lib-menu-item>
  </div>
</ng-container>

<mat-menu #operatorActions *ngIf="hierarchyItem">
  <button mat-menu-item (click)="toggleMasterOperator()">
    <span> {{ hierarchyItem.isMasterOperator ? 'Remove' : 'Apply' }} Master Operator </span>
  </button>
  <button mat-menu-item [disabled]="hierarchyItem.isMasterOperator" (click)="toggleDirectChangesOperate()">
    <span> {{ hierarchyItem.directChangesOperate ? 'Remove' : 'Apply' }} Direct Changes Operate </span>
  </button>
</mat-menu>
